import type { UseFetchOptions } from 'nuxt/app';
export function useCustomFetch<T>(
  url: string | (() => string),
  options: UseFetchOptions<T> = {},
) {
  const runtimeConfig = useRuntimeConfig();

  const props: UseFetchOptions<T> = {
    baseURL: import.meta.server
      ? runtimeConfig.API_SERVER_URL
      : runtimeConfig.public.API_SERVER_URL,
    onRequest({ options }) {
      if (useCookie('csrftoken').value) {
        options.headers.set('X-CSRFToken', `${useCookie('csrftoken').value}`);
        if (import.meta.server) {
          const cookie = useRequestHeader('cookie');
          if (cookie) {
            options.headers.set('cookie', cookie);
          }
        }
      }
    },
    ...options,
  };

  return useFetch(url, props);
}
